module.exports = __webpack_public_path__ + "static/img/bzyy.403f502.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/bzyy.png
// module id = ULtS
// module chunks = 0